// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d1cf57ba","703":"a13726a3"}[chunkId] + ".chunk.js";
};